import React from 'react';

import http from 'Demora/http';

import Rate from 'rc-rate';

import 'rc-rate/assets/index.css';

import modal from 'Demora/modals/modal';

import Loading from 'Demora/Loading';

import AddEditWebsiteReviews from './AddEditWebsiteReviews';

import moment from 'moment';

import './websiteReviews.scss';

import confirm from 'Demora/modals/confirm';

import ReduxConnect from 'Demora/redux-connect';

class WebsiteReviews extends React.Component {
	constructor() {
		super();

		this.state = {
			loaded: false,
			reviews: [],
		};
	}

	componentDidMount() {
		this.getData();
	}

	openAdd = (review) => {
		modal({
			id: 'add_web_review',
			header: 'Add Website Review',
			body: <AddEditWebsiteReviews getData={this.getData} review={review} />,
		});
	};

	getData = () => {
		modal.close('add_web_review');

		http.get('/data/web_reviews/' + this.props.uid).then((data) => {
			if (!data.rufP) {
				return;
			}

			this.setState({
				loaded: true,
				reviews: data.web_reviews,
			});
		});
	};

	editReview = (review) => {
		this.openAdd(review);
	};

	deleteReview = (review) => {
		confirm({
			id: 'deleteWebReview-' + review.id,
			header: 'Delete Your Review',
			message:
				'Are you sure you want to delete your review "' + review.title + '"?',
			confirmFunc: () => this.deleteURL(review),
			confirmButtonText: 'Delete',
		});
	};

	deleteURL = (review) => {
		return http.delete('/data/web_reviews/' + review.id).then(this.getData);
	};

	isUserViewingThemselves = () => {
		return this.props.user.id == this.props.uid;
	};

	render() {
		const state = this.state;

		if (!state.loaded) {
			return <Loading />;
		}

		const isUserViewingThemselves = this.isUserViewingThemselves();

		return (
			<div className='container websiteReviews' style={{ maxWidth: '680px' }}>
				<div className='row'>
					{isUserViewingThemselves && (
						<div className='col-12'>
							<div className='alert alert-warning'>
								<h3>Share Your Experience</h3>
								<p>
									Website reviews gives you an opportunity to tell other people
									what you think of the websites you've tried and use.
								</p>
								<p>
									It doesn't matter whether your experience is a good or bad
									one, all the community asks is that you're honest.
								</p>
								<p>
									You can write a review on any service you want to, just click
									on the button to add. We'll show your review on your profile
									complete with your affiliate link if you add one.
								</p>
							</div>
						</div>
					)}
					{state.reviews.length > 0 && isUserViewingThemselves && (
						<div className='col-12 text-right'>
							<button
								className='btn btn-primary'
								onClick={() => this.openAdd()}
							>
								Add Review
							</button>
						</div>
					)}
					<h3>Reviews</h3>
					{state.reviews.length === 0 && (
						<div className='col-12 text-center'>
							<p>No reviews here yet</p>
							{isUserViewingThemselves && (
								<p>
									<button
										className='btn btn-primary btn-sm'
										onClick={() => this.openAdd()}
									>
										Add Review
									</button>
								</p>
							)}
						</div>
					)}
				</div>
				{state.reviews.map((r) => (
					<div className='card mb-4 websiteReview' key={r.id}>
						<div className='card-body bg-light'>
							<div className='row'>
								<div className='col-12'>
									<h3>
										<a href='{ r.url }'>{r.name}</a>
									</h3>
									<h6 className='small'>
										<a href={r.url} target='_blank'>
											{r.domain}
										</a>
									</h6>
								</div>
							</div>
							<div className='row mb-4'>
								<div className='col-6'>
									<Rate value={r.rate} disabled={true} />
								</div>
								<div className='col-6 text-right text-muted small'>
									{moment.utc(r.created_at).local().format('ll')}
								</div>
							</div>
							<div className='row mb-4'>
								<div className='col-12 h4 mb-2'>{r.title}</div>
								<div className='col-12 website_review'>{r.review}</div>
							</div>
						</div>
						{isUserViewingThemselves && (
							<div className='websiteReviewButtons'>
								<button
									className='btn btn-default'
									onClick={() => this.editReview(r)}
								>
									<i className='far fa-edit'></i>
								</button>
								<button
									className='btn btn-default'
									onClick={() => this.deleteReview(r)}
								>
									<i className='fa fa-trash' aria-hidden='true'></i>
								</button>
							</div>
						)}
					</div>
				))}
			</div>
		);
	}
}

export default ReduxConnect(WebsiteReviews, {
	user: 'user',
});
